/* eslint-disable import/prefer-default-export */
export const isValidUrl = (urlString) => {
  let url;
  try {
    url = new URL(urlString);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
};

export const isValidEmail = (email) =>
  String(email)
    .toLowerCase()
    .match(/^[a-zA-Z0-9._%+\-\']+@[a-zA-Z0-9._%+-]+\.[a-zA-Z]+/);

export const isValidPhone = (phone) =>
  String(phone)
    .toLowerCase()
    .match(/\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/g);

export const isValidFax = (fax) =>
  String(fax)
    .toLowerCase()
    .match(/\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/g);
